import { applyMiddleware, createStore } from 'redux';
import ReduxThunk from 'redux-thunk';
import reducer from '../reducers';

const createGigStore = ({packages, studio, requestContext, general}) =>
    createStore(reducer({packages, studio, requestContext, general}), applyMiddleware(ReduxThunk));

export default createGigStore;
